import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
    Button,
    ComposedModal,
    FormGroup,
    ModalBody,
    ModalFooter,
    ModalHeader,
    TextInput
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';

export class CAROwnerManualInputModal extends Component {
    genericOwnerTemplate = {
        id: null,
        name: '',
        surname: '',
        email: '',
        badgeNumber: ''
    };

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        const model = props.editModal ? props.editModel : this.genericOwnerTemplate;
        const hocCardTranslateCAR = this.props.isTranslate ? window.sessionStorage.getItem("hocCardTranslate") : null; //RITM0954296 

        this.state = {
            model,
            hocCardTranslateCARFields: JSON.parse(hocCardTranslateCAR),

        };
    }

    onSave = () => {
        if (this.validator.allValid()) {
            this.props.onOk(this.state.model);
            // showNotification.success(`${entitiesLabels.SUCCESS}`, "Team Member created successfully");
        } else {
            this.validator.showMessages();
            if (this.state.hocCardTranslateCARFields?.msgWarning == null)
                showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.GENERICOWNER + " fields are invalid.");
            else
                showNotification.warning(this.state.hocCardTranslateCARFields?.msgWarning, this.state.hocCardTranslateCARFields?.msgCARGeneric);
            this.forceUpdate();
        }
    };

    updateState = (inputName, inputValue, objName) => {
        let stateCopy = Object.assign({}, this.state);
        stateCopy[objName][inputName] = inputValue;
        this.setState(stateCopy);
    };

    handleChangeModel = el => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    };

    render() {
        this.validator.purgeFields();
        const validations = {
            name: this.validator.message('name', this.state.model.name, 'required'),
            surname: this.validator.message('surname', this.state.model.surname, 'required'),
            email: this.validator.message('email', this.state.model.email, 'required|email')
        };
        const modalHeader = {
            title: this.props.isEditModal ? this.state.hocCardTranslateCARFields?.insertCAROwnerTitle || 'Edit ' : this.state.hocCardTranslateCARFields?.attachmentAddnewTitle ||'Add new ',
            iconDescription: 'Close',
            buttonOnClick: this.props.onCancel
        };

        return (
            <ComposedModal
                className="light-modal"
                open={true}
                danger="false"
                onClose={() => (false)}
            >
                <ModalHeader className="margin-modal" {...modalHeader} >
                    <p>    {this.state.hocCardTranslateCARFields?.insertCAROwnerTitle || 'Insert CAR Owner'}   </p>
                </ModalHeader>
                <ModalBody className="margin-modal">
                    <div className="bx--grid--full-width">
                        <div className="bx--row">
                            <FormGroup legendText={this.state.hocCardTranslateCARFields?.carNameTitle || "Name*"} className="bx--col-lg-6 bx--col-md-4">
                                <TextInput
                                    id="name"
                                    name="name"
                                    alt="model"
                                    placeholder={this.state.hocCardTranslateCARFields?.carNameTitlePlaceholder || "Input Name"}
                                    value={this.state.model.name || ''}
                                    type="text"
                                    hideLabel={true}
                                    labelText=""
                                    onChange={this.handleChangeModel}
                                    invalid={validations.name != null}
                                    invalidText={this.state.hocCardTranslateCARFields?.msgCARName}
                                />
                                {/*validations.name*/}
                            </FormGroup>
                            <FormGroup legendText={this.state.hocCardTranslateCARFields?.carSurnameTitle || "Surname*"} className="bx--col-lg-6 bx--col-md-4">
                                <TextInput
                                    id="surname"
                                    name="surname"
                                    alt="model"
                                    placeholder={this.state.hocCardTranslateCARFields?.carSurnameTitlePlaceholder || "Input Surname"}
                                    value={this.state.model.surname || ''}
                                    type="text"
                                    hideLabel={true}
                                    labelText=""
                                    onChange={this.handleChangeModel}
                                    invalid={validations.surname != null}
                                    invalidText={this.state.hocCardTranslateCARFields?.msgCARSurname}
                                />
                                {/*validations.surname*/}
                            </FormGroup>
                            <FormGroup legendText={this.state.hocCardTranslateCARFields?.carBadgeNumberTitle || "Badge Number"} className="bx--col-lg-6 bx--col-md-4">
                                <TextInput
                                    id="badgeNumber"
                                    name="badgeNumber"
                                    alt="model"
                                    placeholder=""
                                    value={this.state.model.badgeNumber}
                                    type="text"
                                    hideLabel={true}
                                    labelText=""
                                    onChange={this.handleChangeModel}
                                />
                            </FormGroup>
                            <FormGroup legendText={this.state.hocCardTranslateCARFields?.carEmailTitle || "Email* (Personal Email Addresses are not allowed​)"} className="bx--col-lg-6 bx--col-md-4">
                                <TextInput
                                    id="email"
                                    name="email"
                                    alt="model"
                                    placeholder={this.state.hocCardTranslateCARFields?.carEmailTitlePlaceholder || "Input Email"}
                                    value={this.state.model.email || ''}
                                    type="text"
                                    hideLabel={true}
                                    title={this.state.hocCardTranslateCARFields?.carDonotUsePATitle || "&#9888; Do Not use Personal Accounts"}
                                    labelText=""
                                    onChange={this.handleChangeModel}
                                    invalid={validations.email != null}
                                    invalidText={this.state.hocCardTranslateCARFields?.msgCAREmail}
                                />
                                {/*validations.email*/}
                            </FormGroup>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter >
                    <Button kind="secondary" onClick={this.props.onCancel}>{this.state.hocCardTranslateCARFields?.carCancelTitle || "Cancel"}</Button>
                    <Button kind="primary" onClick={this.onSave}>{this.state.hocCardTranslateCARFields?.carOkTitle || "Ok"}</Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
};

CAROwnerManualInputModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    isTranslate: PropTypes.bool, //RITM0954296
}

//RITM0954296
CAROwnerManualInputModal.defaultProps = {
    isTranslate: false, 
};
//End